import { useCallback, useEffect, useRef, useState } from "react";
import Sheet from "components/Overlays/AnimatedSheet";

export default function EditorPanel({ children, onClose, visible, onExited }) {
    const panel = useRef(null);
    const [node, setNode] = useState(null);
    const opener = useRef(document.activeElement);
    const bindPanel = useCallback((element) => { panel.current = element; setNode(element); element?.querySelector("input:not([disabled])")?.focus(); }, []);
    const close = useRef(onClose);
    close.current = onClose;
    useEffect(() => {
        if (!visible || !node) return;
        const previousFocus = opener.current;
        const previousOverflow = document.body.style.overflow;
        const siblings = Array.from(document.body.children).filter((node) => !node.contains(panel.current) && !node.classList.contains("p-component-overlay"));
        const previous = siblings.map((node) => [node, node.getAttribute("aria-hidden"), node.hasAttribute("inert")]);
        siblings.forEach((node) => { node.setAttribute("inert", ""); node.setAttribute("aria-hidden", "true"); });
        document.body.style.overflow = "hidden";
        panel.current.querySelector("input:not([disabled])")?.focus();
        const focusable = () => Array.from(panel.current.querySelectorAll('button:not([disabled]), input:not([disabled]), select:not([disabled]), a[href], [tabindex="0"]')).filter((node) => !node.closest('fieldset[disabled]'));
        const handleKey = (event) => {
            if (event.key === "Escape") { event.preventDefault(); close.current(); }
            if (event.key !== "Tab") return;
            const elements = focusable();
            const first = elements[0];
            const last = elements[elements.length - 1];
            if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
            else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
        };
        const handleFocus = (event) => {
            if (!panel.current.contains(event.target)) focusable()[0]?.focus();
        };
        document.addEventListener("keydown", handleKey);
        document.addEventListener("focusin", handleFocus);
        return () => {
            document.removeEventListener("keydown", handleKey);
            document.removeEventListener("focusin", handleFocus);
            document.body.style.overflow = previousOverflow;
            previous.forEach(([node, hidden, inert]) => {
                if (hidden === null) node.removeAttribute("aria-hidden"); else node.setAttribute("aria-hidden", hidden);
                if (!inert) node.removeAttribute("inert");
            });
            previousFocus?.focus();
        };
    }, [visible, node]);
    return <Sheet visible={visible} onHide={() => close.current()} onExited={onExited} position="right" blockScroll showCloseIcon={false} closeOnEscape={false} className="currency-editor-sheet"><div ref={bindPanel} role="dialog" aria-modal="true" aria-labelledby="currency-editor-title" aria-describedby="currency-editor-description" className="currency-editor">{children}</div></Sheet>;
}
